import axios from 'axios'
import router from '@/router'
import store from '@/store'

// console.log(process.env.VUE_APP_API_BASE_URL)
// create an axios instance
const service = axios.create({
  baseURL:process.env.VUE_APP_API_BASE_URL

  // withCredentials: true, // send cookies when cross-domain requests
  // timeout: 10000 // request timeout
})
// 请求 拦截
service.interceptors.request.use(config => {
    // do something before request is sent
    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      // config.headers['token']
      config.headers['Set-Cookie'] = 'CookieName=CookieValue; SameSite=Lax'
    }

    return config
  }, error => {
    // do something with request error

    return Promise.reject(error)
  }
)

// 响应 拦截
service.interceptors.response.use(
  response => {
    const res = response.data
    if (response.status === 200) {
      //code 200 兼容活动接口
      if (res.code === 1 || res.code === 200) {
        return res
      } else {
        return Promise.reject(res)
      }
    } else {
      return Promise.reject(res)
    }
  },
  (error) => {
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          break
        case 401:
          break
        case 403:
          error.msg = '拒绝访问(403)'
          break
        case 404:
          error.msg = '请求出错(404)'
          break
        case 408:
          error.msg = '请求超时(408)'
          break
        case 500:
          error.msg = '服务器错误(500)'
          break
        case 501:
          error.msg = '服务未实现(501)'
          break
        case 502:
          error.msg = '网络错误(502)'
          break
        case 503:
          error.msg = '服务不可用(503)'
          break
        case 504:
          error.msg = '网络超时(504)'
          break
        case 505:
          error.msg = 'HTTP版本不受支持(505)'
          break
        default:
          error.msg = `连接出错(${error.response.code})!`
      }
    } else {
      error.msg = '连接服务器失败!'
    }
    return Promise.reject(error)
    // return Promise.reject(new Error('faile'))
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js
